// Member Articles list — dark Growing Circle shell, links out to detail
// which switches into the editorial article surface.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/modules/growing-circle/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
function media(id) { return `${BACKEND}/api/growing-circle/article-media/${id}`; }
function fmt(iso) { try { return new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" }); } catch { return iso || ""; } }

export default function MemberArticleList() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/articles").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);
  if (items === null) return <p className="text-muted-foreground text-sm">Loading…</p>;
  return (
    <div data-testid="member-articles-list">
      <h1 className="font-heading text-3xl tracking-tight mb-8">Articles</h1>
      {items.length === 0 ? (
        <p className="text-muted-foreground" data-testid="articles-empty">No articles yet.</p>
      ) : (
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {items.map((a) => (
            <li key={a.slug} className="group" data-testid={`article-card-${a.slug}`}>
              <Link to={`/growing-circle/articles/${a.slug}`} className="block">
                {a.cover_media_id && (
                  <div className="aspect-[16/10] overflow-hidden rounded-xl mb-4 bg-card">
                    <img src={media(a.cover_media_id)} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                )}
                <p className="text-[0.7rem] uppercase tracking-[0.16em] text-muted-foreground mb-1">{fmt(a.publish_at)}</p>
                <h2 className="font-heading text-2xl leading-tight tracking-tight group-hover:text-primary transition-colors">{a.title}</h2>
                {a.subtitle && <p className="text-muted-foreground mt-1 text-sm">{a.subtitle}</p>}
                <p className="text-xs text-muted-foreground mt-3">By {a.author_name}</p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
